export default function runAfterPageLoad(fun) {
  if (document.readyState !== "loading") {
    fun();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      fun();
    });
  }
}
